import {
  createDirectus,
  rest,
  readItems,
  readUser,
  aggregate,
  updateItems,
  createUser,
  readUsers,
  authentication,
  deleteUser,
  updateUser,
  updateMe,
} from "@directus/sdk";

const client = createDirectus(location.origin)
  .with(authentication("cookie"))
  .with(rest());

async function get(limit, offset, filter, search, sort, fields) {
  let query = { fields: fields ? fields : ["*,groups.*"] };
  if (limit != null) query.limit = limit;
  if (offset != null) query.offset = offset;
  if (sort != null) query.sort = sort;
  let obj = {};
  if (filter && Object.keys(filter).length !== 0) {
    obj.filter = filter;
  }
  if (search && search.length > 0) obj.search = search;

  const totalCount = await client.request(
    aggregate("directus_users", {
      aggregate: { count: "*" },
      query: obj,
    })
  );

  const data = await client.request(readUsers({ ...obj, ...query }));
  return { totalCount: totalCount[0].count, data };
}

async function getGroupsByIds(ids) {
  let obj = {
    filter: { id: { _in: ids } },
  };
  const data = await client.request(readItems("user_groups", obj));

  return data;
}

async function getById(id) {
  return await client.request(
    readUser(id, {
      fields: ["*,groups.*"],
    })
  );
}

async function getByAuthId(id) {
  return await client.request(readUser(id));
}

async function create(data) {
  return await client.request(createUser(data));
}

async function updateById(id, isMine, data) {
  if (isMine)
    return await client.request(updateMe(data, { fields: ["*,groups.*"] }));
  else
    return await client.request(
      updateUser(id, data, { fields: ["*,groups.*"] })
    );
}

async function update(items, data) {
  return await client.request(
    updateItems("directus_users", items, data, { fields: ["*,groups.*"] })
  );
}

async function deleteById(id) {
  return await client.request(deleteUser(id));
}
export default {
  get,
  create,
  update,
  deleteById,
  getById,
  updateById,
  getByAuthId,
  getGroupsByIds,
};
